export enum RowType {
    Single = 'single',
    Double = 'double',
    Location = 'location',
    InputNumber = 'input-number',
    Note = 'note',
    RemoveRowButton = 'remove-row-button',
    NoteWithRemoveButton = 'note-and-remove-button',
    Name = 'name',
    BackCount = 'back-count',
    BackCountNotResolvedTooltip = 'backCountNotResolvedTooltip',
    Template = 'template'
}